import type { PathType } from './types';
import { getPath } from './types';

export const ticketPaths: { [key: string]: PathType } = {
  ticketType: getPath('/interactive/system-admin/ticket-type', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketType'
  ]),
  ticketCategoryGroup: getPath('/interactive/system-admin/ticket-category-group', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketCategoryGroup'
  ]),
  ticketCategory: getPath('/interactive/system-admin/ticket-category', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketCategory'
  ]),
  ticketCategoryEdit: getPath('/interactive/system-admin/ticket-category/edit', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketCategory',
    'action.edit'
  ]),
  ticketCategoryAdd: getPath('/interactive/system-admin/ticket-category/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketCategory',
    'action.add'
  ]),
  ticketCategoryDetail: getPath('/interactive/system-admin/ticket-category/detail', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketCategory',
    'page.detail'
  ]),
  ticketForm: getPath('/interactive/system-admin/ticket-form', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketForm'
  ]),
  ticketFormAdd: getPath('/interactive/system-admin/ticket-form/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketForm',
    'action.add'
  ]),
  ticketFormEdit: getPath('/interactive/system-admin/ticket-form/edit', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketForm',
    'action.edit'
  ]),
  ticketFormDetail: getPath('/interactive/system-admin/ticket-form/detail', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketForm',
    'page.detail'
  ]),
  ticketFormMapping: getPath('/interactive/system-admin/ticket-form-mapping', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketFormMapping'
  ]),
  reason: getPath('/interactive/system-admin/reason', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.reason'
  ]),

  // V2 Ticket paths
  ticketRaising: getPath('/ticket-raising', ['sidebar.home', 'v2.ticketRaising.index']),
  ticket: getPath('/ticket-raising/ticket', ['v2.sidebar.home', 'v2.helpdesk.index', 'v2.sidebar.ticket.index']),
  ticketDetail: getPath('/ticket-raising/ticket/detail', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.ticket.index',
    'action.page'
  ]),
  ticketAdd: getPath('/ticket-raising/ticket/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.ticket.index',
    'action.add'
  ]),
  ticketEdit: getPath('/ticket-raising/ticket/edit', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.ticket.index',
    'action.edit'
  ]),
  myTicket: getPath('/ticket-raising/ticket/my-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.ticket.index',
    'Ticket của tôi'
  ]),
  approval: getPath('/ticket-raising/ticket/approval', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.ticket.index',
    'v2.sidebar.approval'
  ]),
  accept: getPath('/ticket-raising/ticket/accept', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.ticket.index',
    'v2.sidebar.accept'
  ]),
  solution: getPath('/ticket-raising/ticket/solution', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.ticket.index',
    'v2.sidebar.handle'
  ]),
  solutionAdd: getPath('/ticket-raising/ticket/solution/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.ticket.index',
    'v2.sidebar.handle',
    'action.add'
  ]),
  solutionEdit: getPath('/ticket-raising/ticket/solution/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.ticket.index',
    'action.edit'
  ]),
  handle: getPath('/ticket-raising/ticket/handle', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.ticket.index',
    'v2.sidebar.myHandle'
  ]),

  // Sub Layout paths (External Layout)
  ticketAddSub: getPath('/s/ticket/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.ticket.index',
    'action.add'
  ]),
  ticketEditSub: getPath('/s/ticket/edit', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.ticket.index',
    'action.edit'
  ])
};
